// extracted by mini-css-extract-plugin
module.exports = {"top":"ScoreReport-module__top___3nU9h","empty":"ScoreReport-module__empty___end7b","table":"ScoreReport-module__table___3fheb"};